var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"related-product"},[(_vm.path)?_c('InfraLink',{attrs:{"title":_vm.title,"path":_vm.path,"router-link":false,"variant":"standalone"}}):_c('span',[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }